import { useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { decodeJwt } from 'jose';

export function useAuth() {
  const { token, setToken } = useContext(AuthContext);

  // validate token expiration
  useEffect(() => {
    if (!token) return;
    const decoded = decodeJwt(token);
    if (decoded.exp && decoded.exp < Date.now() / 1000) {
      // token is expired, clear it
      setToken('');
      localStorage.removeItem('id_token');
    }
  }, [setToken, token]);

  return {
    token,
    setToken,
  };
}
